import React from 'react';
import * as PropTypes from 'prop-types';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import IconButton from './IconButton';
import { SubjectPropType } from '../../abilities/proptypes';

const AddPersonIconButton = ({ onClick, size, color, disabled, action, subject }) => {
    return (
        <IconButton
            onClick={onClick}
            size={size}
            color={color}
            disabled={disabled}
            subject={subject}
            action={action}
        >
            <PersonAddIcon />
        </IconButton>
    );
};

AddPersonIconButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    size: PropTypes.string,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    subject: SubjectPropType,
    action: PropTypes.string,
};

AddPersonIconButton.defaultProps = {
    size: null,
    disabled: false,
    color: 'default',
    subject: null,
    action: null,
};

export default AddPersonIconButton;
